<label (click)="openModal()" style="display: block;font-size: 15px;text-align: center">
    <i class="fa fa-paperclip"></i>
    <span *ngIf="active_files_length">
        {{active_files_length}}
        <span *ngIf="active_files_length == 1">
            file
        </span>
        <span *ngIf="active_files_length > 1">
            files
        </span>
    </span>
    <span *ngIf="!active_files_length">
        Upload
        <span *ngIf="multiple">
            files
        </span>
        <span *ngIf="!multiple">
            Resume
        </span>
    </span>
</label>
<!-- <mat-label class="input-label text-nowrap" style="display: block;padding: 0;margin-top: -4px;" [title]="label">
    {{label}}
    <span style="color:red" *ngIf="required">*</span>
</mat-label>
<label class="m-0" (click)="openModal()"
    style="display: block;cursor: pointer; font-size: 13px;height:40px;padding-top: 3px;">
    <i class="fa fa-paperclip"></i>&nbsp;
    <span *ngIf="active_files_length">
        {{active_files_length}}
        <span *ngIf="active_files_length == 1">
            file
        </span>
        <span *ngIf="active_files_length > 1">
            files
        </span>
    </span>
    <span *ngIf="!active_files_length">
        Select
        <span *ngIf="multiple">
            files
        </span>
        <span *ngIf="!multiple">
            a file
        </span>
    </span>
</label> -->